module.exports = __webpack_public_path__ + "static/img/todayCollection.dd26ddd2.png";